import { createSelector } from 'reselect';
import { performanceChartSelector } from './simple-selectors';

export const performanceChartDataTypeSelector = createSelector(
    performanceChartSelector,
    performanceChart => performanceChart.dataType
);